const DISCARD_MESSAGE = 'You have unsaved changes. Leave this page and discard them?';
const STATE_KEY = '__kioskSettingsUnsavedGuard';

function getSharedState() {
    if (!globalThis[STATE_KEY]) {
        globalThis[STATE_KEY] = { dirty: false };
    }
    return globalThis[STATE_KEY];
}

function settingsPageIsActive() {
    return !!document.querySelector('#mgr_index_paging .settings-manager-page');
}

function campaignFormChangesFlagIsSet() {
    const el = document.getElementById('form_changes');
    return !!el && String(el.value).toLowerCase() === 'true';
}

export function markSettingsFormsDirty() {
    getSharedState().dirty = true;
}

export function markSettingsFormsClean() {
    getSharedState().dirty = false;
    const el = document.getElementById('form_changes');
    if (el) {
        el.value = 'false';
    }
}

export function scheduleSettingsFormsClean() {
    window.setTimeout(markSettingsFormsClean, 0);
}

export function settingsHaveUnsavedChanges() {
    if (!settingsPageIsActive()) {
        return false;
    }
    return getSharedState().dirty || campaignFormChangesFlagIsSet();
}

export function confirmDiscardSettingsChanges() {
    if (!settingsHaveUnsavedChanges()) {
        return true;
    }
    return window.confirm(DISCARD_MESSAGE);
}

export function isSettingsNavUserClick(ev) {
    return !!(ev && ev.currentTarget);
}

export function bindSettingsUnsavedTracking($) {
    const selector = '#mgr_index_paging .settings-manager-page .settings-content :input';
    $(document)
        .off('input.settingsUnsaved change.settingsUnsaved', selector)
        .on('input.settingsUnsaved change.settingsUnsaved', selector, function () {
            markSettingsFormsDirty();
        });
}
